
import declare from	"dojo/_base/declare";
import _ from "underscore";
import lang from "dojo/_base/lang";
import Controller from "csi/action/Controller";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from	"csi/xml";
import PostRequest from "csi/comm/PostRequest";

const MassDeleteFormulatedProduct = declare([Controller, ActionControllerMixin], {

	/**
	 * @override
	 */
	process() {
		const req = this.m_action.m_request;
		console.log(this.m_formData.getSelectedValue());
		new PostRequest(req.m_module, req.m_operation)
			.addParameter("AddURLs", this.m_formData.getSelectedValue())
			.post({})
			.then(lang.hitch(this, this._onPublishResponse));
	},

	/**
	*@override
	* Refresh data in where used table
	*/
	postProcessSuccess() {
		this.widget.refreshData();
	},

	/**
	*@override
	* Only allow selection of nodes with Write access
	*/
	_canAggregatePlacement(ctx, fd) {
		return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
	},
});

export = MassDeleteFormulatedProduct;
